// ©2024 Austin App House. All rights reserved.

export const normalizeWorkTypeOption = (item) => {
  if (!item || typeof item !== 'object') return null;

  if (item.label != null && item.value != null) {
    return {
      ...item,
      label: String(item.label),
      value: item.value,
    };
  }

  const title = item.title ?? item.name ?? item.label ?? '';
  const id = item._id ?? item.value ?? item.id;
  const resolvedValue = id ?? (title || null);
  const resolvedLabel = title || (id != null ? String(id) : '');

  if (resolvedValue == null && !resolvedLabel) return null;

  return {
    label: resolvedLabel,
    value: resolvedValue,
    item: item.item ?? item,
  };
};

export const normalizeWorkTypesValue = (workTypes) => {
  if (!Array.isArray(workTypes)) return [];
  return workTypes.map(normalizeWorkTypeOption).filter(Boolean);
};

export const workTypesNeedNormalization = (workTypes) => (
  Array.isArray(workTypes)
  && workTypes.some((item) => item && (item.label == null || item.value == null))
);
